/** Guarded localStorage access — it throws in private-mode Safari, so every call is wrapped. */
export function readLocalStorage(key: string): string | null {
  try {
    return globalThis.localStorage?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function writeLocalStorage(key: string, value: string): void {
  try {
    globalThis.localStorage?.setItem(key, value);
  } catch {
    // A preference that cannot be remembered still applies until the tab closes.
  }
}
